export const GET_USERS_QUANTITY_REQUEST = 'GET_USERS_QUANTITY_REQUEST';
export const GET_USERS_QUANTITY_SUCCESS = 'GET_USERS_QUANTITY_SUCCESS';
export const GET_USERS_QUANTITY_FAILURE = 'GET_USERS_QUANTITY_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/constants/get_users_quantity.constants.js